import React from 'react';
import { CTAButton } from '../CTAButton';
import { AUTHOR_IMAGE } from '../../data/content';
const insights = ['In piccoli errori durante la diagnosi.', 'In decisioni prese durante la pianificazione.', 'In movimenti biomeccanicamente poco prevedibili.', 'In dettagli che passano inosservati quando si approva un setup.'];
export function About() {
  return <section className="bg-ink-900 px-4 py-12 sm:py-16" data-id="element-44" data-mp="ynh0bzo97prk">
      <div className="mx-auto max-w-2xl lg:max-w-5xl" data-id="element-45" data-mp="b0indbzcezye">
        <h2 className="text-center font-display text-[26px] leading-tight text-white sm:text-4xl" data-id="element-46" data-mp="60wefeqjs5ve">
          🦷 Chi è la <span className="text-brand-400" data-id="element-47" data-mp="jskl32i1224z">Dott.ssa Karito</span>?
        </h2>

        <div className="mt-7 lg:grid lg:grid-cols-[300px_1fr] lg:items-start lg:gap-8" data-id="element-48" data-mp="f1cba5cscera">
          <div className="mx-auto w-full max-w-[280px] overflow-hidden rounded-3xl border border-brand-500/25 bg-ink-800 lg:mx-0 lg:max-w-none" data-id="element-49" data-mp="ezhv14cglatj">
            <img src={AUTHOR_IMAGE} alt="Dott.ssa Karito, specialista in trattamenti con allineatori" className="h-auto w-full object-cover" loading="lazy" data-id="element-50" data-mp="3jehmunlix3gn" />
            <div className="border-t border-white/10 px-4 py-3 text-center" data-id="element-51" data-mp="386id29d9hf0u">
              <p className="text-[15px] font-extrabold text-white" data-id="element-52" data-mp="3d0csh0lu37u4">Dott.ssa Karito</p>
              <p className="text-[12.5px] text-brand-400" data-id="element-53" data-mp="3hyee9tan9l9a">
                Creatrice del Sistema Anti-Rifiniture™
              </p>
            </div>
          </div>

          <div className="mt-6 lg:mt-0" data-id="element-54" data-mp="2p9h6wl7z18vb">
            <p className="text-[15px] leading-relaxed text-white/70" data-id="element-55" data-mp="2paig0k5fflae">
              Dopo aver lavorato con centinaia di trattamenti con allineatori, la Dott.ssa
              Karito ha individuato uno schema che continuava a ripetersi.
            </p>
            <p className="mt-3 text-[16px] font-bold leading-relaxed text-white" data-id="element-56" data-mp="9ibf6bxll4wk">
              Molte rifiniture non comparivano per sfortuna. Cominciavano molto prima.
            </p>
            <ul className="mt-4 space-y-2" data-id="element-57" data-mp="ejimk9vtw22p">
              {insights.map(item => <li key={item} className="rounded-xl border border-white/10 bg-ink-800 px-3.5 py-2.5 text-[13.5px] leading-snug text-white/70" data-id="element-58" data-mp="2aipsix8w1epo">
                  {item}
                </li>)}
            </ul>
            <p className="mt-4 text-[15px] leading-relaxed text-white/70" data-id="element-59" data-mp="2fkynfz5bmquf">
              Per questo ha sviluppato il{' '}
              <strong className="font-bold text-white" data-id="element-60" data-mp="1ruazk4f0fqm8">Sistema Anti-Rifiniture™</strong>: una
              biblioteca clinica progettata per consultare rapidamente protocolli e aiutarti a
              prendere decisioni con maggiore criterio clinico prima, durante e al termine di
              un trattamento.
            </p>
          </div>
        </div>

        <div className="mx-auto mt-8 max-w-md" data-id="element-61" data-mp="185adqp3fjwz3">
          <CTAButton label="Voglio il metodo della Dott.ssa Karito" sublabel="Accesso a vita per €19" data-id="element-62" data-mp="183z9ko62on7g" />
        </div>
      </div>
    </section>;
}